import Vue from 'vue'

import Employee from "Models/Employee"
import County from "Models/StaticData/County"
import Workstation from "Models/Workstation"
import Role from "Models/Role"
import Permission from "Models/Permission"

import Appointment from "Models/Appointment"
import Customer from "Models/Customer"
import Offer from "Models/Offer"
import OfferProduct from "Models/OfferProduct"
import Vehicle from "Models/Vehicle"
import Product from "Models/Product"
import InspectionIndex from "Models/InspectionIndex"

class Api {
    constructor()
    {
        this.$http = window.axios
        Vue.prototype.$db = this

        this.County = County
        this.Employee = Employee
        this.Role = Role
        this.Permission = Permission
        this.Workstation = Workstation

        this.Appointment = Appointment
        this.Customer = Customer
        this.Offer = Offer
        this.OfferProduct = OfferProduct
        this.Vehicle = Vehicle
        this.Product = Product
        this.InspectionIndex = InspectionIndex
    }
}

export default new Api()
